import React from 'react';
import PropTypes from 'prop-types';
// Permissions
import permissions from 'constants/Permissions';
// HOCs
import withPermissions from 'hocs/WithPermissions';
// Models
import mCustomer from 'models/cpm/customer';
// Custom
import { cpmCustomerDataShape } from 'constants/PropTypesShapes';
import InformationItem from 'components/items/InformationItem';
import ParkingCategoryIdIntegIcon from 'cpmCarparks/assets/parkingCategories/ParkingCategoryIdIntegIcon';

const CustomerItem = ({
  customer,
  light,
  labelBuilder,
  rightButton,
  onClick,
  hasPermission,
}) => {
  if (!customer) return null;

  // Permissions
  const { pCpm: { parkingCategoryRead } } = permissions;

  return (
    <InformationItem
      light={light}
      icon={!hasPermission({ needed: parkingCategoryRead, permissionsOrContext: 'carparkPermissions' }) ? 'itemCustomer' : null}
      customIcon={hasPermission({ needed: parkingCategoryRead, permissionsOrContext: 'carparkPermissions' }) ? <ParkingCategoryIdIntegIcon withTooltip parkingCategoryId={mCustomer.getParkingCategoryId(customer)} /> : null}
      label={labelBuilder ? labelBuilder(customer) : null}
      value={mCustomer.fullName(customer)}
      rightButton={rightButton}
      onClick={onClick}
    />
  );
};

CustomerItem.propTypes = {
  customer: cpmCustomerDataShape.isRequired,
  light: PropTypes.bool,
  labelBuilder: PropTypes.func,
  rightButton: PropTypes.node,
  onClick: PropTypes.func,
  hasPermission: PropTypes.func.isRequired,
};

CustomerItem.defaultProps = {
  light: false,
  labelBuilder: null,
  rightButton: null,
  onClick: null,
};

module.exports = withPermissions(CustomerItem);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/customers/CustomerItem.js